import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PostTemplateForm from "./PostTemplateForm";
import FullPageLoader from "../../common/FullPageLoader";
import { getPostTemplateByIdApi, updatePostTemplateApi } from "../../api/postTemplateService";
/* ---------- DATE FORMAT ---------- */
const formatDateForInput = (isoString) => {
  if (!isoString) return "";
  return new Date(isoString).toISOString().split("T")[0];
};
const EditPostTemplate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { postId } = location.state || {};
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState(null);
  const [message, setMessage] = useState("");
  const [apiErrors, setApiErrors] = useState({});
  /* ---------- GET TEMPLATE ---------- */
  useEffect(() => {
    if (postId) {
      fetchTemplate(postId);
    } else {
      setLoading(false);
      setMessage("Post Template ID not found");
    }
  }, [postId]);
  const fetchTemplate = async (id) => {
    try {
      setLoading(true);
      const res = await getPostTemplateByIdApi(id);
      setFormData(res?.data);
    } catch (error) {
      console.error("Get Post Template Error:", error);
      setMessage("Failed to load template");
    } finally {
      setLoading(false);
    }
  };
  /* ---------- UPDATE TEMPLATE ---------- */
  const handleUpdate = async (payload, setErrors) => {
    setSaving(true);
    setMessage("");
    setApiErrors({});
    try {
      /*
       * New request body
       */
      const requestBody = {
        name: payload.name,
        fromDate: payload.fromDate,
        toDate: payload.toDate,
        status: payload.status,
        orderId: Number(payload.orderId),
        categoryId: payload.categoryId,
        description: payload.description,
        link: payload.link,
        image: payload.image,
      };

      const response = await updatePostTemplateApi(postId, requestBody);
      /* ---------- API ERROR ---------- */
      if (response?.error) {
        setApiErrors(response.error);
        setErrors(response.error);
        return;
      }
      /* ---------- SUCCESS ---------- */
      if (response?.success) {
        navigate("/banner-template", {
          state: {
            toastMessage: response?.message || "Banner Template updated successfully!",
            toastType: "success",
          },
        });
        return;
      }
      setMessage(response?.message || "Update failed");
    } catch (error) {
      console.error("Update Banner Template Error:", error);
      const responseData = error?.response?.data;
      if (error?.response?.status === 422) {
        const backendErrors = responseData?.error || responseData?.errors || {};
        if (typeof backendErrors === "object") {
          setApiErrors(backendErrors);
          setErrors(backendErrors);
        } else {
          setMessage(responseData?.message || "Validation failed");
        }
      } else {
        setMessage(responseData?.message || "Update failed");
      }
    } finally {
      setSaving(false);
    }
  };
  return (
    <>
      {(loading || saving) && <FullPageLoader />}
      {!loading && formData && (
        <PostTemplateForm
          initialValues={{
            name: formData?.name || "",

            fromDate: formatDateForInput(formData?.fromDate),

            toDate: formatDateForInput(formData?.toDate),

            categoryId: formData?.categoryId || formData?.category?._id || formData?.category || "",

            status: formData?.status || "ACTIVE",
            orderId: formData?.orderId ?? "",
            description: formData?.description || "",

            link: formData?.link || "",

            // IMPORTANT
            image: formData?.imageUrl || "",
          }}
          onSubmit={handleUpdate}
          loading={saving}
          message={message}
          apiErrors={apiErrors}
          isEdit={true}
          onCancel={() => navigate("/banner-template")}
        />
      )}
    </>
  );
};
export default EditPostTemplate;
